__turbopack_context__.v({
  "accordion": "FaqCategories-module-scss-module__LO_QVW__accordion",
  "accordionButton": "FaqCategories-module-scss-module__LO_QVW__accordionButton",
  "accordionContent": "FaqCategories-module-scss-module__LO_QVW__accordionContent",
  "accordionContentOpen": "FaqCategories-module-scss-module__LO_QVW__accordionContentOpen",
  "accordionIcon": "FaqCategories-module-scss-module__LO_QVW__accordionIcon",
  "accordionIconOpen": "FaqCategories-module-scss-module__LO_QVW__accordionIconOpen",
  "categoriesTitle": "FaqCategories-module-scss-module__LO_QVW__categoriesTitle",
  "categoriesTitleDesktop": "FaqCategories-module-scss-module__LO_QVW__categoriesTitleDesktop",
  "container": "FaqCategories-module-scss-module__LO_QVW__container",
  "faqListWrapper": "FaqCategories-module-scss-module__LO_QVW__faqListWrapper",
  "gridLayout": "FaqCategories-module-scss-module__LO_QVW__gridLayout",
  "inner": "FaqCategories-module-scss-module__LO_QVW__inner",
  "linkButton": "FaqCategories-module-scss-module__LO_QVW__linkButton",
  "linkButtonUnderline": "FaqCategories-module-scss-module__LO_QVW__linkButtonUnderline",
  "linkButtonWrapper": "FaqCategories-module-scss-module__LO_QVW__linkButtonWrapper",
  "linksWrapperDesktop": "FaqCategories-module-scss-module__LO_QVW__linksWrapperDesktop",
  "linksWrapperDesktopSticky": "FaqCategories-module-scss-module__LO_QVW__linksWrapperDesktopSticky",
  "linksWrapperMobile": "FaqCategories-module-scss-module__LO_QVW__linksWrapperMobile",
});
